"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.enableScroll = exports.disableScroll = void 0;
var keys = [37, 38, 39, 40, 32, 9];

var preventDefault = function preventDefault(e) {
  return e.preventDefault();
};

var preventDefaultForScrollKeys = function preventDefaultForScrollKeys(e) {
  if (keys.indexOf(e.keyCode) !== -1) {
    preventDefault(e);
    return false;
  }
};

var disableScroll = function disableScroll() {
  window.addEventListener('DOMMouseScroll', preventDefault, false);
  window.addEventListener('wheel', preventDefault, {
    passive: false
  });
  window.addEventListener('mousewheel', preventDefault, {
    passive: false
  });
  window.addEventListener('touchmove', preventDefault, {
    passive: false
  });
  window.addEventListener('keydown', preventDefaultForScrollKeys, false);
};

exports.disableScroll = disableScroll;

var enableScroll = function enableScroll() {
  window.removeEventListener('DOMMouseScroll', preventDefault, false);
  window.removeEventListener('wheel', preventDefault, {
    passive: false
  });
  window.removeEventListener('mousewheel', preventDefault, {
    passive: false
  });
  window.removeEventListener('touchmove', preventDefault, {
    passive: false
  });
  window.removeEventListener('keydown', preventDefaultForScrollKeys, false);
};

exports.enableScroll = enableScroll;
var _default = {
  disableScroll: disableScroll,
  enableScroll: enableScroll
};
exports["default"] = _default;